import { render, staticRenderFns } from "./AgenciesSinglePlacementsPdp.vue?vue&type=template&id=3f706f8f&"
import script from "./AgenciesSinglePlacementsPdp.vue?vue&type=script&lang=js&"
export * from "./AgenciesSinglePlacementsPdp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports